<template>
  <div ref="app" id="app" :class="appClasses">
    <div id="top">
      <navigation-icon v-on:toggle-menu-state="toggleMenuState" :nav-icon-classes="navIconClasses"></navigation-icon>
    </div>
    <navigation-menu v-on:navigating="closeMenu"></navigation-menu>
    <div id="content" @click="closeMenu">
      <router-view :scrollPosition="scrollPosition"></router-view>
      <page-footer></page-footer>
    </div>
  </div>
</template>

<script>
import NavigationIcon from '@/components/NavigationIcon'
import NavigationMenu from '@/components/NavigationMenu'
import PageFooter from '@/components/PageFooter'
export default {
  name: 'app',
  data () {
    return {
      menuOpen: false,
      scrollPosition: 0
    }
  },
  methods: {
    toggleMenuState () {
      this.menuOpen = !this.menuOpen
    },
    closeMenu () {
      this.menuOpen = false
    },
    handleScroll () {
      this.scrollPosition = window.scrollY
    }
  },
  computed: {
    appClasses () {
      return this.menuOpen ? 'menu-open' : ''
    },
    navIconClasses () {
      return this.menuOpen ? 'open' : ''
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  components: {
    NavigationIcon,
    NavigationMenu,
    PageFooter
  }
}
</script>

<style lang="sass">
  @import assets/styles/scss/variables.scss
  @import assets/styles/scss/mixins.scss

  ::-moz-selection
    background: $mainColor

  ::selection
    background: $mainColor

  #app
    #top,
    #content
      left: 0
      transition: .5s
    &.menu-open
      #top,
      #content
        left: -255px

  // PACE

  .pace
    -webkit-pointer-events: none
    pointer-events: none
    -webkit-user-select: none
    -moz-user-select: none
    user-select: none

  .pace-inactive
    display: none

  .pace .pace-progress
    background: $mainColor
    position: fixed
    z-index: 2000
    top: 0
    right: 100%
    width: 100%
    height: 2px

  // Custom

  body
    margin: 0
    font-family: $effra
    background-color: $lightGrey

    > a, a::after
      @include transitions(0.1s)

    > a:active
      transition: none

  a
    text-decoration: none !important
    color: $black

    &.link-main
      color: $mainColor

  p
    font-size: 1.3em
    @media screen and (min-width: $break-medium)
        font-size: 1.1em

    @media screen and (min-width: $break-large)
        font-size: 1.3em

  #top
    pointer-events: none
    box-sizing: border-box
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    width: 100%
    height: 20%
    position: fixed
    z-index: 1000
    background-color: transparent
    padding-top: 10%
    padding-right: 6%

    @media screen and (min-width: $break-medium)
      padding-right: 8%

    @media screen and (min-width: $break-large)
      padding-right: 9%

  #content
    overflow: hidden
    position: relative
    background-color: $white
    @include box-shadow(5px, 0, 3px, -3px, $grey)

  .body
    width: 77.5%
    margin: 0 15% 0 7.5%
    padding-bottom: 80px

    @media screen and (min-width: $break-small)
      //width: 30%

    //@media screen and (min-width: $break-medium)
    //  width: 80%
    //  margin: 0 15% 0 10%

    @media screen and (min-width: $break-large)
      width: 70%
      margin: 0 auto

    > .logo
      width: 37%
      float: left

      @media screen and (min-width: $break-small)
        width: 30%

      @media screen and (min-width: $break-medium)
        width: 25%

      @media screen and (min-width: $break-large)
        width: 20%

      > .content
        width: 52%
        float: right

        @media screen and (min-width: $break-small)
          width: 64%

        @media screen and (min-width: $break-medium)
          width: 69%

        @media screen and (min-width: $break-large)
          width: 73%

  #page-heading
    margin-top: 35px

    @media screen and (min-width: $break-small)
      margin-top: 40px

    @media screen and (min-width: $break-medium)
      margin-top: 45px

    @media screen and (min-width: $break-large)
      margin-top: 50px

  .sub-title-1
    color: $mainColor
    font-size: #{$subtitle1BaseFontSize}pt
    line-height: #{$subtitle1BaseLineHeight}px

    > a
      color: $black
      text-decoration: none

    @media screen and (min-width: $break-small)
      font-size: #{$subtitle1BaseFontSize + 5}pt
      line-height: #{$subtitle1BaseLineHeight + 5}px

    @media screen and (min-width: $break-medium)
      font-size: #{$subtitle1BaseFontSize + 10}pt
      line-height: #{$subtitle1BaseLineHeight + 10}px

    @media screen and (min-width: $break-large)
      font-size: #{$subtitle1BaseFontSize + 15}pt
      line-height: #{$subtitle1BaseLineHeight + 15}px

  .sub-title-2
    font-size: #{$subtitle2BaseFontSize}pt;
    line-height: #{$subtitle2BaseLineHeight}px;
    color: $grey;

    > a
      color: $black
      text-decoration: none

    @media screen and (min-width: $break-small)
      font-size: #{$subtitle2BaseFontSize + 5}pt
      line-height: #{$subtitle2BaseLineHeight + 5}px

    @media screen and (min-width: $break-medium)
      font-size: #{$subtitle2BaseFontSize + 10}pt
      line-height: #{$subtitle2BaseLineHeight + 10}px

    @media screen and (min-width: $break-large)
      font-size: #{$subtitle2BaseFontSize + 15}pt
      line-height: #{$subtitle2BaseLineHeight + 15}px

  #description
    font-size: #{$descriptionBaseFontSize}pt
    line-height: #{$descriptionBaseLineHeight}px

    @media screen and (min-width: $break-small)
      font-size: #{$descriptionBaseFontSize + 4}pt
      line-height: #{$descriptionBaseLineHeight + 5}px

    @media screen and (min-width: $break-medium)
      font-size: #{$descriptionBaseFontSize + 8}pt
      line-height: #{$descriptionBaseLineHeight + 10}px

    @media screen and (min-width: $break-large)
      font-size: #{$descriptionBaseFontSize + 12}pt
      line-height: #{$descriptionBaseLineHeight + 15}px

  #summary
    font-size: #{$summaryBaseFontSize}pt
    line-height: #{$summaryBaseLineHeight}px

    @media screen and (min-width: $break-small)
      font-size: #{$summaryBaseFontSize + 4}pt
      line-height: #{$summaryBaseLineHeight + 5}px

    @media screen and (min-width: $break-medium)
      font-size: #{$summaryBaseFontSize + 8}pt
      line-height: #{$summaryBaseLineHeight + 10}px

    @media screen and (min-width: $break-large)
      font-size: #{$summaryBaseFontSize + 12}pt
      line-height: #{$summaryBaseLineHeight + 15}px

  #sub-sections
    background-color: $darkGrey
    position: relative
    color: $grey

    > .sub-section
      padding: 100px 15% 30px

      &:last-of-type
        padding-bottom: 20px

      > .heading
        text-transform: uppercase

        > a
          text-decoration: none
          color: $mainColor

          &:active
            color: $mainColorDark

  ul.unstyled
    list-style: none
    padding-left: 0
    line-height: 40px

    > li
      font-size: 1.75em

      > a
        text-decoration: none
        color: $grey

        &:hover
          color: $mainColor

          > span.side-note
            color: $lightGrey

        &:active
          color: $mainColorDark

        > span.side-note
          font-size: .7em

      > a.active
        color: $mainColor

    &.inline
      > li
        display: inline
        padding: 0 10px

        &:first-of-type
          padding-left: 0

        &:last-of-type
          padding-right: 0

  .box
    width: 100%
    text-align: center
    margin-bottom: 20px
    @include transitions(0.3s)

    > .heading
      margin: 0 auto
      border-bottom: 2px solid $grey
      color: $mainColor
      @include transitions(0.3s)

      > .title
        margin-bottom: 10px

    > .content
      width: 100%

      > p
        @include transitions(0.3s)

      > img
        display: block
        margin: 25px auto 0

    &.active,
    &:hover
      color: $lightGrey
      cursor: pointer

      > .heading
        border-color: $lightGrey

      > .content > p
        color: $lightGrey

  .grid
    > .box
      float: left

      > .heading
        width: 175px

      @media screen and (min-width: $break-medium)
        width: 40%
        margin: 0 5%

        &:nth-last-child(1):nth-child(odd)
          margin: 0 30%

  .guide
    padding-top: 60px
    margin: 0 0 30px
    @include transitions(0.3s)

    > .heading
      margin-bottom: 10px
      > a
        color: $mainColor !important

  .description
    color: $grey
    margin: 5px 0

  .published-date
    margin-top: 0px
    color: $lightGrey

  #empty-status
    margin: 50px 30px 30px

  .hover-light:hover
    color: $lightGrey
    @include transitions(0.3s)

  .profile-photo
    width: 201px
    height: 203px

  .block
    margin: 0
    box-sizing: border-box
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box

    @media screen and (min-width: $break-medium)
      width: 50%

  .block-left
    float: left

    @media screen and (min-width: $break-medium)
      padding-right: 10px

  .block-right
    float: right

    @media screen and (min-width: $break-medium)
      padding-left: 10px
      text-align: right

  #toggle-menu
    pointer-events: all
    float: right

    > #nav-icon
      position: relative
      top: 1px

      @media screen and (min-width: $break-large)
        top: 2px

      &.open
        top: 0px

        @media screen and (min-width: $break-large)
          top: 1px

  #close-menu
    color: $grey
    font-size: 1.8em
    padding-right: 20px

    &:hover
      color: $mainColor

  .menu-icon
    color: $mainColor
    font-size: 1.2em

    @media screen and (min-width: $break-small)
      font-size: 1.4em

    @media screen and (min-width: $break-medium)
      font-size: 1.6em

    @media screen and (min-width: $break-large)
      font-size: 1.8em

  .menu
    text-align: right

    > ul
      margin-top: 6px

      > li
        font-size: #{$menuBaseFontSize}pt
        line-height: #{$menuBaseLineHeight}px

        &.title
          font-size: #{$menuBaseFontSize+6}pt
          line-height: #{$menuBaseLineHeight+12}px

          @media screen and (min-width: $break-small)
            font-size: #{$menuBaseFontSize+10}pt
            line-height: #{$menuBaseLineHeight+20}px

          @media screen and (min-width: $break-medium)
            font-size: #{$menuBaseFontSize+18}pt
            line-height: #{$menuBaseLineHeight+36}px

          @media screen and (min-width: $break-large)
            font-size: #{$menuBaseFontSize+22}pt
            line-height: #{$menuBaseLineHeight+44}px

    @media screen and (min-width: $break-small)
      > ul
        margin-top: 8px

        > li
          font-size: #{$menuBaseFontSize+4}pt
          line-height: #{$menuBaseLineHeight+8}px

    @media screen and (min-width: $break-medium)
      > ul
        margin-top: 10px

        > li
          font-size: #{$menuBaseFontSize+6}pt
          line-height: #{$menuBaseLineHeight+12}px

    @media screen and (min-width: $break-large)
      > ul
        margin-top: 14px

        > li
          font-size: #{$menuBaseFontSize+8}pt
          line-height: #{$menuBaseLineHeight+16}px

  li.menu > ul
    margin: 0

  .main-nav-item,
  .nav-item
    cursor: pointer

  .align-left
    text-align: left

  .align-right
    text-align: right

  .align-center
    text-align: center

  .easy
    @include transitions(0.3s)

    &:active
      transition: none

  .pointer:hover
    cursor: pointer

  .clear
    clear: both
</style>



// WEBPACK FOOTER //
// App.vue?07212cca